// extracted by mini-css-extract-plugin
export default {"form":"NewsUploadForm_form__P75wN","sun-editor":"NewsUploadForm_sun-editor__eEJks","sun-editor-editable":"NewsUploadForm_sun-editor-editable__Xnz0O"};